import { Cushion, Rectangle, Typography } from '@pitchero/react-ui';
import { DateTime } from 'luxon';
import PropTypes from 'prop-types';
import React from 'react';
import CLUB_PROP_TYPES from '../../lib/prop-types/club';
import MatchDetails from './match-details';
import TrainingSession from './training-session';

const MatchDay = ({ club, date, sortedData }) => {
  if (sortedData.length === 0) {
    return null;
  }

  return (
    <Rectangle
      fill="white"
      style={{
        border: '1px solid #d9d9d9',
        borderBottom: '0',
        overflow: 'hidden',
        marginTop: '10px',
      }}
      responsive={[{ minWidth: 'fullHeader', props: { radius: 'rounded' } }]}
    >
      <Rectangle fill="#fafafa" borderBottom="1px solid #d9d9d9">
        <Cushion all="small">
          <Typography size={16} weight="bold" color="black" align="center" component="h3">
            {DateTime.fromISO(date).toFormat('ccc dd LLL')}
          </Typography>
        </Cushion>
      </Rectangle>
      {sortedData.map((item) => {
        if (item.sortType === 'training') {
          return <TrainingSession key={item.id} club={club} session={item} />;
        }
        if (item.sortType === 'fixture') {
          return (
            <MatchDetails
              key={`${item.id}-${item.teamId}`}
              match={item}
              club={club}
              type={item.hasOutcome ? 'result' : 'fixture'}
              isMobile
            />
          );
        }

        return null;
      })}
    </Rectangle>
  );
};

MatchDay.propTypes = {
  club: CLUB_PROP_TYPES.isRequired,
  date: PropTypes.string.isRequired,
  sortedData: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default MatchDay;
